import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import divisionService from '../services/divisionService';

const divisionsCollectionName = 'divisions';
export const useDivision = () => {
  return useQuery({
    queryKey: [divisionsCollectionName],
    queryFn: () => divisionService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddDivision = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: divisionService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [divisionsCollectionName] });
    },
  });
};

export const useEditDivision = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: divisionService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [divisionsCollectionName] });
    },
  });
};

export const useDeleteDivision = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: divisionService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [divisionsCollectionName] });
    },
  });
};

export const useDivisionIdByName = (divisionName) => {
  return useQuery({
    queryKey: [divisionsCollectionName, divisionName],
    queryFn: () => divisionService.getIdByName(divisionName),
    enabled: !!divisionName,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  })
};

export const useDivisionNameById = (divisionId) => {
  return useQuery({
    queryKey: [divisionsCollectionName, divisionId],
    queryFn: () => divisionService.getNameById(divisionId),
    enabled: !!divisionId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

